import Vue from 'vue'
import {
    Button,
    Toast,
    Dialog,
    Empty,
    Grid,
    GridItem,
    Col,
    Row,
    Image as VanImage,
    Icon,
    Divider,
    Loading,
    Field,
    Radio,
    RadioGroup,
    Picker,
    Popup,
    Area,
    Uploader,
    Switch,
    Form,
    List,
    CellGroup,
    Cell,
    Tag,
    Sticky,
    Search,
    NoticeBar,
    Checkbox,
    CheckboxGroup,
    Popover,
    Card,
    Panel,
    NavBar,
    Tab,
    Tabs,
    Badge,
    Skeleton,
    Lazyload,
    ActionSheet,
    Overlay,
    Circle,
    Progress,
    Rate,
} from 'vant'
import 'vant/lib/index.less';



Vue.use(Button)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Empty)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Col)
Vue.use(Row)
Vue.use(VanImage)
Vue.use(Icon)
Vue.use(Divider)
Vue.use(Loading)
Vue.use(Field)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Area)
Vue.use(Uploader)
Vue.use(Switch)
Vue.use(List)
Vue.use(Form)
Vue.use(CellGroup)
Vue.use(Cell)
Vue.use(Tag)
Vue.use(Sticky)
Vue.use(Search)
Vue.use(NoticeBar)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Popover)
Vue.use(Card)
Vue.use(Panel)
Vue.use(NavBar)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Badge)
Vue.use(Skeleton)
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
    lazyComponent: true,
})
Vue.use(ActionSheet)
Vue.use(Overlay)
Vue.use(Circle)
Vue.use(Progress)
Vue.use(Rate)
